module.exports = __webpack_public_path__ + "img/1212b_3.cec4afe3.jpg";